// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3ol6y","log":"ModalInventoryLogs_log__3MWfV","date":"ModalInventoryLogs_date__3aMRy","userName":"ModalInventoryLogs_userName__2Sm9e"};